
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 1l.842 2.189c.201.524.302.785.459 1.006.138.195.309.366.504.504.22.157.482.258 1.006.46L11 6l-2.189.842c-.524.201-.786.302-1.006.459-.195.138-.365.309-.504.504-.157.22-.258.482-.46 1.006L6 11l-.842-2.189c-.201-.524-.302-.786-.459-1.006a2.142 2.142 0 00-.504-.504c-.22-.157-.482-.258-1.006-.46L1 6l2.189-.842c.524-.201.785-.302 1.006-.459.195-.138.365-.309.504-.504.157-.22.258-.482.46-1.006L6 1z","fill":"#F8F8FB","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    